import React, {Component, createRef, forwardRef} from "react";
import Styles from "./FJStockVideoButton.module.less";
import InlineSVG from "react-inlinesvg";
import StockMediaIcon from "../../../icon/stock-media.svg";
import FJLocalStore from "../../../store/FJLocalStore";
import FJDropDown from "fj-components/FJDropDown";
import FJButton from "fj-components/FJButton";
import FJViewConstant from "../../../constant/FJViewConstant";
import VideoIcon from '../../../icon/video.svg';
import PhotoIcon from "../../../icon/photo.svg";
import MusicIcon from "../../../icon/music.svg";
import recordArrow from "../../../icon/recordarrow.svg";

const ForwardTrigger = forwardRef(((props, ref) => {
	return (
		<div className={Styles.record} ref={ref}>
			<InlineSVG src={StockMediaIcon} className={Styles.left_icon}/>
			<span className={Styles.text}>{FJLocalStore._('stock-media')}</span>
      <InlineSVG src={recordArrow} className={Styles.arrow}/>
		</div>
	);
}));

class FJStockVideoButton extends Component{

	constructor(props) {
		super(props);


		this.dropDown = createRef();
	}


	getView = () => {

		let lists = [];

		[
			{
				text: 'stock-video-menu-text',
				icon: VideoIcon,
				type: FJViewConstant.STOCK_VIDEO_VIDEO
			},
			{
				text: 'stock-photo-menu-text',
				icon: PhotoIcon,
				type: FJViewConstant.STOCK_VIDEO_PHOTO
			},
			{
				text: 'stock-music-menu-text',
				icon: MusicIcon,
				type: FJViewConstant.STOCK_VIDEO_MUSIC
			}
		].forEach((item, index) => {
			lists.push(
				<FJButton key={index}
									text={FJLocalStore._(item.text)}
									className={Styles.item_btn}
									textClass={Styles.btn_text}
									icon={item.icon}
									iconClass={Styles.icon}
									onClick={(e) => {
										e.stopPropagation();
										this.props.openStockModal && this.props.openStockModal(item.type)
									}}
				/>
			)
		})

		return lists;
	}

	render() {
		return (
			<FJDropDown overlay={
				<div className={Styles.list_box}>
					{
						this.getView()
					}
				</div>
			}
                  useAnchorBody
                  isTopLayer
									canTriggerActive={true}
									ref={this.dropDown}
									placement='bottomLeft'
			>
				<ForwardTrigger />
			</FJDropDown>
		)
	}

}


export default FJStockVideoButton;